import { render } from "./Article.vue?vue&type=template&id=2fef3269&scoped=true"
import script from "./Article.vue?vue&type=script&lang=js"
export * from "./Article.vue?vue&type=script&lang=js"

import "./Article.vue?vue&type=style&index=0&id=2fef3269&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2fef3269"]])

export default __exports__